/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import Loading from 'components/Loading/Loading';

@translate()
@inject('projectDetailsStore')
@observer
class ProjectLocation extends React.Component<*> {
  levels: Array<string> = ['workspace', 'room', 'building', 'site'];

  getValuesForItemsWithField(field: string): Array<string> {
    return this.levels
      .map((l: string) => this.props[l] && this.props[l][field])
      .filter((p: string) => p);
  }

  render(): React.Element<*> {
    const t: Function = this.props.t;
    const details: any = this.props;

    const phones: Array<string> = this.getValuesForItemsWithField('contact_phone');

    const contacts: Array<string> = this.getValuesForItemsWithField('contact');

    if (!details.site) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <h3>{t('general:projects.labels.location')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:company')}:</b>
              </td>
              <td>{details.company.name ? details.company.name : details.company}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.site')}:</b>
              </td>
              <td>{details.site.name}</td>
            </tr>
            {details.site && (
              <tr>
                <td>
                  <b>{t('general:locations.labels.site_address')}:</b>
                </td>
                <td>
                  <SiteAddress {...details.site.address} />
                </td>
              </tr>
            )}
            <tr>
              <td>
                <b>{t('general:locations.labels.building_transport')}:</b>
              </td>
              <td>{details.building.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.lab_room')}:</b>
              </td>
              <td>{details.room.name} </td>
            </tr>
            {details.workspace && (
              <tr>
                <td>
                  <b>{t('general:locations.labels.system_workspace')}:</b>
                </td>
                <td>{details.workspace.name}</td>
              </tr>
            )}
            {phones[0] && (
              <tr>
                <td>
                  <b>{t('general:labels.contact_number')}:</b>
                </td>
                <td>{phones[0]}</td>
              </tr>
            )}
            {contacts[0] && (
              <tr>
                <td>
                  <b>{t('general:locations.labels.contact')}:</b>
                </td>
                <td>{contacts[0]}</td>
              </tr>
            )}
            {/*

                            //deprecated?

                           details.contact_fax &&
                           <tr>
                               <td><b>{t('general:labels.contact_fax_number')}:</b></td>
                               <td>
                                   <Link to={'tel:' + details.contactFax}>
                                       {details.contact_fax}
                                   </Link>
                               </td>
                           </tr>
                           */}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default ProjectLocation;
